"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Line(props) {
  var children = props.children,
      strokeWidth = props.strokeWidth,
      type = props.type,
      value = props.value,
      color = props.color,
      style = props.style,
      background = props.background;
  var className = (0, _classnames.default)((0, _styles.progressClass)('line', type), props.className);
  var innerStyle = {
    background: color,
    backgroundSize: '1em 1em',
    width: value / 100 * 100 + "%",
    borderRadius: strokeWidth / 2
  };
  return _react.default.createElement("div", {
    className: className,
    style: style
  }, _react.default.createElement("div", {
    className: (0, _styles.progressClass)('background'),
    style: {
      height: strokeWidth,
      background: background,
      borderRadius: strokeWidth / 2
    }
  }, _react.default.createElement("div", {
    className: (0, _styles.progressClass)('front'),
    style: innerStyle
  })), children !== undefined && _react.default.createElement("div", {
    className: (0, _styles.progressClass)('content')
  }, children));
}

Line.propTypes = {
  background: _propTypes.default.string,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  strokeWidth: _propTypes.default.number,
  style: _propTypes.default.object,
  type: _propTypes.default.oneOf(['success', 'info', 'warning', 'error', 'danger']),
  value: _propTypes.default.number
};
Line.defaultProps = {
  strokeWidth: 8
};
var _default = Line;
exports.default = _default;